import React, { useEffect, useState } from 'react';

import Grid from '@mui/material/Grid2';

import { 
  Creature,
} from "@dndModels";
import { SIZE_MAP } from "@dndModels/Constants";

// import API from "../../utilities/system_api";
import { makeStyles } from "@utilities/theme_utilities";

import AddButton from "@components/input/buttons/icon_buttons/AddButton";
import RemoveButton from "@components/input/buttons/RemoveButton";
import DisplayStringWithReplacements from "@dndComponents/display/DisplayStringWithReplacements";
import FlexBox from '@components/layout/FlexBox';

interface Props { 
  creature: Creature;
  count: number;
  disabled: boolean;
  onChange: (count: number) => void;
}

// const api = API.getInstance();

export default function CreatureParticipant({ 
  creature,
  count,
  disabled,
  onChange
}: Props) {
  const [in_encounter, setInEncounter] = useState(count);
  const [expanded, setExpanded] = useState(false);

  useEffect(() => {
    if (count !== in_encounter) {
      setInEncounter(count);
    }
    // eslint-disable-next-line
  }, [count]);
    
  const useStyles = makeStyles()((theme) => {
    return ({
      root: {
        // margin: "4px",
        backgroundColor: theme.palette.secondary.main
      },
    });
  });

  const { classes, cx } = useStyles();

  return (
    <div className='padded'>
      <FlexBox direction="row" className={cx(classes.root,"padded")} style={{ width: "100%" }}>
        <FlexBox xs_expand={0}>
          <AddButton
            disabled={disabled}
            onClick={ () => {
              const newCount = in_encounter + 1;
              setInEncounter(newCount);
              onChange(newCount);
            }}
          />
        </FlexBox>
        <FlexBox xs_expand={0} className="centered">
          &nbsp;{ in_encounter }&nbsp;
        </FlexBox>
        <FlexBox xs_expand={0}>
          <RemoveButton
            disabled={ disabled || in_encounter === 0 }
            onClick={ () => {
              const newCount = in_encounter - 1;
              setInEncounter(newCount);
              onChange(newCount);
            }}
          />
        </FlexBox>
        <FlexBox direction="column" className="clickable padded"
          onClick={() => {
            setExpanded(!expanded);
          }}>
          <FlexBox xs_expand={0}>
            { creature.true_name }
          </FlexBox>
          <FlexBox xs_expand={0} className='small_label gray'>
            { SIZE_MAP[creature.size_num] } CR { creature.challenge_rating } { creature.creature_type }
          </FlexBox>
        </FlexBox>
        { expanded &&
          <FlexBox style={{ backgroundColor: "black", border: "1px solid" }}>
            <DisplayStringWithReplacements display_string={creature.description} />
          </FlexBox>
        }
      </FlexBox>
    </div>
  );
}
